import { Flex, Tooltip, Button, Text } from '@chakra-ui/react';
import { sampleLifecycleGroupTitle } from '@texas/components/shared/samples/translations';
import {
  SampleLifecycleGroup,
  sampleLifecycleGroupConfig,
} from '@texas/components/shared/samples/types';
import { BlueDot } from '@texas/components/shared/tracker/BlueDot';
import { convertToEnum } from '@texas/utils/helpers/enumHelpers';
import { t } from 'i18next';

import {
  SamplesOverviewModal,
  SamplesOverviewModalProps,
} from './SamplesOverviewModal';
import { useValueDisclosure } from '@texas/hooks/useValueDisclosure';
import { SamplesWidgetContext } from './SamplesWidget';
import { useActiveContext } from '@texas/hooks/useActiveContext';

export function MinifiedView() {
  const {
    isOpen: overviewIsOpen,
    value,
    onClose: overviewOnClose,
    onOpen: overviewOnOpen,
  } = useValueDisclosure<SamplesOverviewModalProps>();

  const samplesContext = useActiveContext(SamplesWidgetContext);

  return (
    <Flex gap={2} flexWrap="wrap">
      {samplesContext.groupConfigs.map((s) => {
        const groupEnum = convertToEnum(SampleLifecycleGroup, s);

        const config =
          sampleLifecycleGroupConfig[s as keyof typeof SampleLifecycleGroup];
        const am = samplesContext.sampleGroups[groupEnum].length;

        const hasAnyChangeSinceLastTrack = samplesContext.sampleGroups[
          groupEnum
        ].some((sample) => sample.isChangedSinceLastTrack);

        return (
          <BlueDot show={hasAnyChangeSinceLastTrack} key={s}>
            <Tooltip label={sampleLifecycleGroupTitle(groupEnum, t)}>
              <Flex gap={1} align="center" opacity={am === 0 ? 0.5 : 1}>
                <Button
                  variant="texas-light"
                  size="lg"
                  justifyContent="space-between"
                  rightIcon={config.icon}
                  onClick={() =>
                    overviewOnOpen({
                      groupEnum,
                      header: sampleLifecycleGroupTitle(groupEnum, t),
                    })
                  }
                >
                  <Text variant="header-medium">{am}</Text>
                </Button>
              </Flex>
            </Tooltip>
          </BlueDot>
        );
      })}
      {value && (
        <SamplesOverviewModal
          {...value}
          isOpen={overviewIsOpen}
          onClose={overviewOnClose}
        />
      )}
    </Flex>
  );
}
